import { Doc } from "../../../../common/common.model";
import { CustomerRef } from "../customers/customer.model";

export enum PaymentMode {
    CASH                        =   'CASH',
    CHEQUE                      =   'CHEQUE',
    NEFT                        =   'NEFT',
    RTGS                        =   'RTGS'
}

export class Payment extends Doc {
    public customer             :   CustomerRef;
    public amount               :   number;
    public date                 :   Date;
    public mode                 :   PaymentMode;
    public transactionId        :   string;

    constructor(data: any = {}) {
        super(data);
        this.customer           =   new CustomerRef(data.customer);
        this.amount             =   data.amount         ||  0;
        this.date               =   typeof data.date === 'object' ? data.date.toDate(): new Date(data.date);
        this.mode               =   data.mode           ||  PaymentMode.CASH;
        this.transactionId      =   data.transactionId  ||  '';
    }

    public toJson() {
        return {
            ...this,
            customer            :   this.customer.toJson()
        };
    }
}